import apiConfig from '../config'
import CheckStatus from '../checkStatus'

interface ServerResponse {
  data: RequestSuccessType
}

interface RequestSuccessType {
  token: string | undefined
}

interface RequestResponse extends RequestSuccessType {
  isErr: string | undefined
}

export type StepPasswordApiProps = {
  password: string
  token: string
}
const stepPasswordApi = ({
  password,
  token,
}: StepPasswordApiProps): Promise<RequestResponse> => {
  return apiConfig()
    .post<ServerResponse>(`/user/password/restore`, {
      token,
      password,
    })
    .then(({ data }) => {
      return { isErr: undefined, token: data.data.token }
    })
    .catch(({ response }) => {
      response.response && CheckStatus(response.response.status)

      return { isErr: response.data.message, token: undefined }
    })
}

export default stepPasswordApi
